export default __webpack_public_path__ + "static/logo-text-light-23410d74731e1856cbc2147c459782bc.webp";